import Authenticate from './authenticate/authenticate.vue';
import AmendSpassword from './amend-spassword/amend-spassword.vue';
import AmendSuccess from './amend-success/amend-success.vue';

export default [
  {
    path: 'authenticate',
    name: 'authenticate',
    component: Authenticate
  },
  {
    path: 'amend-spassword',
    name: 'amendSpassword',
    component: AmendSpassword
  },
  {
    path: 'amend-success',
    name: 'amendSuccess',
    component: AmendSuccess
  }
];
